import React from 'react';

import { Typography } from '../../../designComponents';
import {
  InfoRowStyled,
  VerticalSpaceStyled,
} from '../../../style/reusableStyle';
import { JobDetailsContainerStyled } from './style';

type Props = {
  pricing: string;
  shippingAddress: string;
};

const CostAndShipping = ({ pricing, shippingAddress }: Props) => {
  return (
    <JobDetailsContainerStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        COST & SHIPPING
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Pricing :</Typography>
          <Typography className="value">€ {pricing}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Shipping Address :</Typography>
          <Typography className="value">{shippingAddress}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </JobDetailsContainerStyled>
  );
};

export default CostAndShipping;
